import React from 'react'
import { RedocStandalone } from 'redoc'

import Navbar from './Navbar'

const SinegyDocumentation = () => {
    // https://pointnet.github.io/redoc-editor/#/
    return (
        <div>
            <Navbar/>
            <RedocStandalone
                specUrl = '/swagger.json'
                options = {
                    {
                        theme: {
                            spacing: {
                                sectionVertical: 5
                            },
                            typography: {
                                fontFamily: 'Montserrat, sans-serif',
                                headings: {
                                    fontFamily: 'Montserrat, sans-serif'
                                },
                                code: {
                                    fontFamily: 'Montserrat, sans-serif'
                                }
                            },
                            responses: {
                                success: {
                                    backgroundColor: '#00ff00'
                                }
                            },
                            rightPanel: {
                                backgroundColor: '#666'
                            }
                        },
                        disableSearch: false,
                        expandDefaultServerVariables: true,
                        expandResponses: 'all',
                        expandSingleSchemaField: true,
                        scrollYOffset: '.nav-bar',
                        hideDownloadButton: true,
                        hideLoading: false,
                        pathInMiddlePanel: false,
                        requiredPropsFirst: true,
                        suppressWarnings: true,
                        showConsole: true
                    }
                }
            />
        </div>
    )
}

export default SinegyDocumentation
